<template>
  <div class="text-and-media-container" :class="[{ lessCopy: smallCopy }, { shown: visible }]">
    <div class="animation-container" :class="beatData.mediaPos">
      <div
        v-if="beatData.copy"
        class="copy"
        :class="beatData.mediaPos"
        :style="beatData.copyMax ? `max-width: ${beatData.copyMax}` : ''"
        v-html="mobileMode && beatData.copyMobile ? beatData.copyMobile : beatData.copy"
      />
    </div>
    <div v-if="beatData.media || beatData.video" class="media" :class="beatData.mediaPos || 'center'">
      <template v-if="beatData.media && typeof(beatData.media) === 'string'">
        <img :src="beatData.media" :alt="beatData.title">
      </template>
      <template v-else-if="beatData.media && Array.isArray(beatData.media)">
        <div v-for="(item, index) in beatData.media" :key="`img-${index}`" class="wipe-container">
          <div class="cover"></div>
          <img class="part" :src="item" :alt="beatData.title">
        </div>
      </template>
      <video v-if="beatData.video" :src="beatData.video" autoplay loop muted ref="video" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    beatData: {
      type: Object,
      default: () => {}
    },
    visible: {
      type: Boolean,
      default: false
    },
    mobileMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    smallCopy () {
      if (this.beatData.copy.length < 100) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    visible: function(val) {
      if (val) {
        this.playVideo()
      } else {
        this.stopVideo()
      }
    }
  },
  methods: {
    playVideo () {
      let target = this.$refs['video']
      if (target) {
        target.muted = false
        target.play()
      }
    },
    stopVideo () {
      let target = this.$refs['video']
      if (target) {
        target.pause()
        target.muted = true
        target.currentTime = 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/_variables';
@import '@/assets/style/_fonts';

.text-and-media-container {
  position: relative;
  height: 100%;
  height: -webkit-fill-available;

  &.lessCopy {
    .animation-container {
      top: 25%;
    }
  }
}

.animation-container {
  position: absolute;
  top: 15%;
  z-index: 1;
  overflow: hidden;

  &.left {
    left: 50%;

    @include media($bp-tablet) {
      left: 0;
      text-align: left;
    }
  }

  @include media($bp-tablet) {
    top: 20%;
  }
}

.copy {
  display: inline-block;
  line-height: 1.2em;
  font-size: 4vw;
  text-align: left;
  white-space: nowrap;

  &.left {
    margin-left: auto;
  }

  @include media($bp-hd) {
    font-size: $font-size-xl;
  }

  @include media($bp-desktop-xxl) {
    font-size: $font-size-l;
  }

  @include media($bp-desktop-l) {
    font-size: $font-size-ml;
    max-width: 75%;
  }
  @include media($bp-tablet) {
    // font-size: $font-size-m;
    max-width: 100%;
  }
  @include media($bp-phone-m) {
    font-size: $font-size-m;
  }
}

.media {
  position: relative;
  img, video {
    max-width: 50vw;

    @include media($bp-desktop-l) {
      max-width: 75vw;
    }

    @include media($bp-tablet) {
      max-width: calc(100vw - #{$space-ms * 2});
    }
  }
  .wipe-container {
    width: auto;
    overflow: hidden;

    .cover {
      @include fill-parent;
      background-color: black;
      transform: translateY(0);
      transition: transform 1s $ease-expo;
    }
  }
  &.center {
    @include center-in-parent;
    top: 55%;

    .wipe-container {
      @include center-in-parent;
    }
  }
  &.right, &.left {
    position: absolute;
    top: 55%;
    left: 40%;
    transform: translateY(-40%);
  }
  &.right {
    .wipe-container {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);

      @include media($bp-tablet) {
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
  &.left {
    left: 0;
  }
  @include media($bp-tablet) {
    &.left, &.right {
      @include center-in-parent;
      top: 60%;
    }
  }
}

.shown .media .wipe-container{
  .cover {
    transform: translateY(100%);
    transition: transform 1s $ease-expo;
  }
  &:nth-child(1) .cover {
    transition-delay: .8s;
  }
  &:nth-child(2) .cover {
    transition-delay: .5s;
  }
}
</style>
